import axios from 'axios'
import router from '../router'

// Cliente API base
const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

// Interceptores para autenticación
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    
    if (token) {
      // Normalizar el formato del token (asegurar que use "Bearer" con B mayúscula)
      if (token.toLowerCase().startsWith('bearer ')) {
        const tokenValue = token.substring(7) // Extraer el token sin el prefijo
        config.headers.Authorization = `Bearer ${tokenValue}` // Reconstruir con B mayúscula
      } else {
        config.headers.Authorization = `Bearer ${token}` // Añadir prefijo si no existe
      }
      
      console.log('Authorization header:', config.headers.Authorization.substring(0, 25) + '...')
    }
    
    return config
  },
  error => Promise.reject(error)
)

apiClient.interceptors.response.use(
  response => {
    console.group('Respuesta API')
    console.log('URL:', response.config.url)
    console.log('Status:', response.status)
    console.log('Data:', response.data)
    console.groupEnd()
    return response
  },
  error => {
    console.group('Error API')
    console.log('URL:', error.config?.url)
    console.log('Status:', error.response?.status)
    console.log('Data:', error.response?.data)
    console.log('Headers enviados:', error.config?.headers)
    console.groupEnd()
    
    // Si es error 401, limpiar localStorage y redirigir
    if (error.response && error.response.status === 401) {
      console.warn('Sesión expirada o token inválido. Redirigiendo a login...')
      // Eliminar credenciales locales
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      // Navegar a login y forzar recarga para limpiar el estado en memoria
      try {
        router.push('/login')
      } catch (e) {
        // ignore
      }
      // Forzar reload para asegurar que Vuex se inicialice desde localStorage vacío
      if (typeof window !== 'undefined') {
        window.location.replace('/login')
      }
    }
    
    return Promise.reject(error)
  }
)

export default apiClient